import Alert from 'antd/es/alert';

import type { FundingConfiguration } from 'api';

type Props = {
  instruction?: FundingConfiguration;
};

export const FundingInstructionsWarning = ({ instruction }: Props) => {
  if (!instruction) return null;

  const { beneficiary, currency_iso: currencyIso } = instruction;

  const message =
    // crypto-specific warning
    beneficiary?.wallet_address && beneficiary?.crypto_network ? (
      <>
        Please only send{' '}
        <b>
          {currencyIso} via the {beneficiary.crypto_network} protocol.
        </b>{' '}
        Funds sent via other protocols will not be received and cannot be
        recovered.
      </>
    ) : (
      <>
        Please make sure to include your funding <b>reference</b> in payment
        details.
      </>
    );

  return <Alert type="warning" showIcon message={message} />;
};
